import { render, staticRenderFns } from "./ScoreBar.vue?vue&type=template&id=07520c8b&scoped=true"
import script from "./ScoreBar.vue?vue&type=script&lang=js"
export * from "./ScoreBar.vue?vue&type=script&lang=js"
import style0 from "./ScoreBar.vue?vue&type=style&index=0&id=07520c8b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07520c8b",
  null
  
)

export default component.exports